import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { techDocsExpandableNavigationAddonModule } from '@backstage/plugin-techdocs-module-addons-contrib/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { catalogModule } from './modules/catalog';
import { navModule } from './modules/nav';
import { backofficePlugin } from './modules/backoffice';
import { clienteExternoPlugin } from './modules/clienteExterno';
import { secretManagerPlugin } from './modules/secretManager';
import { lojinhaPlugin } from './modules/lojinha';
import { approvalsPlugin } from './modules/approvals';
import { iacRunsModule } from './modules/iacRuns';
import { clusterShopModule } from './modules/clusterShop';
import { securityModule } from './modules/security';
import { documentationPlugin } from './modules/documentation';
import { TechneSignInPage } from './modules/signin/TechneSignInPage';
import {
  adoSelectFormField,
  ociSelectFormField,
  techneCidrFormField,
  techneOkeCompartmentFormField,
  techneOkeTagsFormField,
  techneTeamOwnerFormField,
} from './modules/scaffolder/ociSelectFormField';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => <TechneSignInPage {...props} />,
  },
});

export default createApp({
  features: [
    catalogPlugin,
    catalogModule,
    navModule,
    techDocsExpandableNavigationAddonModule,
    backofficePlugin,
    secretManagerPlugin,
    lojinhaPlugin,
    approvalsPlugin,
    iacRunsModule,
    clusterShopModule,
    securityModule,
    documentationPlugin,
    clienteExternoPlugin,
    createFrontendModule({
      pluginId: 'app',
      extensions: [
        signInPage,
        ociSelectFormField,
        adoSelectFormField,
        techneCidrFormField,
        techneTeamOwnerFormField,
        techneOkeCompartmentFormField,
        techneOkeTagsFormField,
      ],
    }),
  ],
});
